import { yupResolver } from "@hookform/resolvers/yup";
import { EditarDataCampanhaStyle } from "./style";
import { useForm } from "react-hook-form";
import { Input } from "../../Input";
import { EditarCampanhaSchema } from "../../../schemas/campanha";
import api from "../../../services/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import Loading from "../../Loading";
import { useAuth } from "../../../providers/Auth";

export const EditarCriativoCampanha = ({ campanha, state, buscarCampanhas }) => {
  const {
    register,
    handleSubmit,
    reset,
  } = useForm();

  const [criativos, setCriativos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  function listarCriativos() {
    setLoading(true);
    api
      .get("/criativo", { params: { status: "ativo" } })
      .then((response) => {
        setCriativos(response.data.data.criativos);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
        setLoading(false);
      });
  }


  function buscarCriativoPorCliente() {
    setLoading(true);
    api
      .get(`/criativo/cliente/${campanha.cliente_id}`)
      .then((response) => {
        setLoading(false);
        setCriativos(response.data.data.criativos);
        reset({ criativo_id: campanha.criativo_id || "" });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Erro ao buscar dados");
      });
  }

  function editarCriativo(value) {
    api
      .patch(`/campanhas/${campanha.id}`, value)
      .then((response) => {
        toast.success("Criativo editado com sucesso!");
        buscarCampanhas();
        state(false);
      })
      .catch((error) => {
        toast.error("Erro ao editar criativo");
      });
  }

  useEffect(() => {
    if (user && (user.permissoes.includes("admin") || user.permissoes.includes("atendimento")) || user.permissoes.includes("produtor")) {
      return listarCriativos();
    }

    if (campanha.cliente_id) {
      buscarCriativoPorCliente();
    }
  }, [campanha])

  return (
    <EditarDataCampanhaStyle>
      <div className="body">
        <form onSubmit={handleSubmit(editarCriativo)}>
          <span onClick={() => state(false)} className="close">
            X
          </span>
          {!loading ? <>
            <label className="label">Selecione um novo criativo</label>
            <select {...register("criativo_id")}>
              <option value="">Selecione um criativo</option>
              {criativos.map((criativo) => (
                <option key={criativo.id} value={criativo.id}>
                  {criativo.titulo}
                </option>
              ))}
            </select>
            <div className="flex">
              <span onClick={() => editarCriativo({ criativo_id: "" })} className="remover">Remover</span>
              <button type="submit">Salvar</button>
            </div>
          </> : <Loading />}
        </form>
      </div>
    </EditarDataCampanhaStyle>
  );
};
